import React from 'react';
import { Link } from 'react-router-dom';

const MenuItems = (props) => {
    const { parentMenu, secondParentMenu, activeMenu } = props;

    return (
        <React.Fragment>
            <li className={parentMenu === 'Home' ? 'current-menu-item' : ''}>
                <Link to="/" className={activeMenu === "/" ? "active-menu" : ""}>Home</Link>
            </li>
            <li className={parentMenu === 'about' ? 'current-menu-item' : ''}>
                <Link to="/about" className={activeMenu === "/about" ? "active-menu" : ""}>About</Link>
            </li>
            <li className={parentMenu === 'Services' ? 'dropdown current-menu-item' : 'dropdown'}>
                <Link to="#">Services</Link>
                <ul className="sub-menu">
                    <li>
                        <Link to="/security-consulting" className={activeMenu === "/security-consulting" ? "active-menu" : ""}>Security Consulting</Link>
                        <ul className="sub-menu">
                    <li>
                        <Link to="/cyber-security" className={activeMenu === "/cyber-security" ? "active-menu" : ""}>Cyber Security</Link>
                    </li>
                    </ul>
                    </li>
                    <li>
                        <Link to="/audit-&-compliance" className={activeMenu === "/audit-&-compliance" ? "active-menu" : ""}>Audit & Compliance</Link>
                    </li>
                    <li>
                        <Link to="/cloud-security" className={activeMenu === "/cloud-security" ? "active-menu" : ""}>Cloud Security</Link>
                    </li>
                    <li>
                        <Link to="/network-security" className={activeMenu === "/network-security" ? "active-menu" : ""}>Network Secuirty</Link>
                    </li>
                    <li>
                        <Link to="/design-&-implementation" className={activeMenu === "/design-&-implementation" ? "active-menu" : ""}>Design & Implementation</Link>
                    </li>
                    <li>
                        <Link to="/managed-it-services" className={activeMenu === "/managed-it-services" ? "active-menu" : ""}>Managed IT Services</Link>
                        <ul className="sub-menu">
                    <li>
                        <Link to="/security-operations-center" className={activeMenu === "/security-operations-center" ? "active-menu" : ""}>Security Operations Center(SOC)</Link>
                    </li>
                    <li>
                        <Link to="/network-operations-center" className={activeMenu === "/network-operations-center" ? "active-menu" : ""}>Network Operations Center(NOC)</Link>
                    </li>
                    </ul>
                    </li>
                    <li>
                        <Link to="/ot-iot-security" className={activeMenu === "/top-notch-roofing-restoration" ? "active-menu" : ""}>OT, IoT Security</Link>
                    </li>
                    <li>
                        <Link to="/api-security" className={activeMenu === "/top-notch-roofing-restoration" ? "active-menu" : ""}>API Security</Link>
                    </li>
                    <li>
                        <Link to="/offensive-security-red-teaming" className={activeMenu === "/top-notch-roofing-restoration" ? "active-menu" : ""}>Offensive Security, Red Teaming</Link>
                    </li>
                    <li>
                        <Link to="/vulnerability-assessment" className={activeMenu === "/top-notch-roofing-restoration" ? "active-menu" : ""}>Vulnerability Assessment</Link>
                    </li>
                </ul>
            </li>
            <li className={parentMenu === 'Project' ? 'current-menu-item' : ''}>
                <Link to="/news-events">News & Events</Link>
            </li>
            <li className={parentMenu === 'blog' ? 'current-menu-item' : ''}>
                <Link to="/careers">Careers</Link>
            </li>
            <li className={parentMenu === 'contact' ? 'current-menu-item' : ''}>
                <Link to="/contact" className={activeMenu === "/contact" ? "active-menu" : ""}>Contact</Link>
            </li>
            
        </React.Fragment>
    );
}

export default MenuItems;